export class Header {
  constructor() {
    this.classNames = {
      active: 'menu-item--active',
      bodyOverflowHidden: 'afu-overflow-hidden',
      buttonNav: 'b-af-header__button-nav',
      dropdownArrow: 'menu-item__arrow',
      dropdownMenuLink: 'menu-item__link',
      header: 'b-af-header',
      headerHovered: 'b-af-header--hovered',
      headerNav: 'b-af-header__nav',

      headerNavItem: 'menu-item',
      headerNavItemHasSubmenu: 'menu-item-has-children',
      headerNavItemHasSubmenuLink: 'menu-item-has-children > a',
      headerNavSubmenu: 'sub-menu',
      headerOpen: 'b-af-header--open',
      headerSticky: 'b-af-header--sticky',
      headerStickyVisible: 'b-af-header--sticky-visible',
      megaMenuBlock: 'afb-mega-menu',

      megaMenuBlockContainer: 'afb-mega-menu__container',

      megaMenuBlockInner: 'afb-mega-menu__inner',
      megaMenuNoLink: 'mega-menu-no-link',
    };

    this.properties = {
      activeItemOffset: '--active-item-offset',
    };

    this.pageScrollTop = window.scrollY;
  }

  initialize() {
    const header = document.querySelector(`.${this.classNames.header}`);

    if (!header) {
      return;
    }

    const headerNavItemHasSubmenu = Array.from(document.querySelectorAll(
      `.${this.classNames.headerNav} .${this.classNames.headerNavItemHasSubmenu}`
    ));

    const headerButtonNav = document.querySelector(
      `.${this.classNames.buttonNav}`
    );

    this.handleMobileNav({ button: headerButtonNav });
    this.handleStickyHeader({ header });
    this.toggleHeaderSticky({ header });

    this.handleArrows({ items: headerNavItemHasSubmenu });
    this.onHistoryChange();
    this.backgroundClick({ items: headerNavItemHasSubmenu });

    this.handleHeaderHovered({ header });

    this.onClickOutside({
      callBack: () => {
        if (window.innerWidth <= 991) {
          return;
        }

        if (headerNavItemHasSubmenu.length === 0) {
          return;
        }

        headerNavItemHasSubmenu.forEach((item) => {
          item.classList.remove(this.classNames.active);
        });
      },
      element: header,
    });

    const megaMenuNoClickLinks = Array.from(document.querySelectorAll(
      `.${this.classNames.megaMenuNoLink}`
    ));
    megaMenuNoClickLinks.forEach((item) => {
      item.addEventListener('click', function (event) {
          event.preventDefault();
      });
    });
  }

  handleArrows({ items }) {
    if (items.length === 0) {
      return;
    }

    items.forEach((item) => {
      if (item.classList.contains(this.classNames.headerNavItemHasSubmenu)) {
        const wrapper = document.createElement('div');

        wrapper.classList.add(this.classNames.dropdownMenuLink);

        const link = item.firstChild;

        wrapper.innerHTML = link.innerHTML;
        link.innerHTML = '';
        link.appendChild(wrapper);

        link.appendChild(this.createArrow());
      }
    });

    this.handleClicks({ items });
  }

  createArrow() {
    const arrow = document.createElement('div');

    arrow.innerHTML = `<svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5.375 6L9.75 1" stroke="currentColor"/></svg>`;

    arrow.classList.add(this.classNames.dropdownArrow);

    return arrow;
  }

  handleClicks({ items }) {
    items.forEach((item) => {
      item.addEventListener('click', (event) => {
        if (
          // event.target.matches(`.${this.classNames.dropdownMenuLink}`) ||
          event.target.matches(`.${this.classNames.dropdownArrow}`) ||
          event.target.matches(`.${this.classNames.dropdownArrow} *`) ||
          event.target.matches(
            `.${this.classNames.headerNavItemHasSubmenuLink}`
          )
        ) {
          event.preventDefault();

          this.toggleElementClass({ item, items });
        }
      });
    });
  }

  backgroundClick({ items }) {
    document.body.addEventListener('click', function (event) {
      if (event.target === document.body) {
        items.forEach((item) => {
          item.classList.remove('menu-item--active');
        });
      }
    });
  }

  toggleElementClass({ items, item }) {
    items.forEach((element) => {
      if (element !== item) {
        element.classList.remove(this.classNames.active);
      }
    });

    if (this.isSubMenuOpen({ item })) {
      item.classList.toggle(this.classNames.active);

      return;
    }

    item.classList.add(this.classNames.active);

    this.scrollToClickedItem({ item });
  }

  scrollToClickedItem({ item }) {
    setTimeout(() => {
      item.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 525);
  }

  isSubMenuOpen({ item }) {
    return item.classList.contains(this.classNames.active);
  }

  handleMobileNav({ button }) {
    if (!button) {
      return;
    }

    button.addEventListener(
      'click',
      this.toggleMobileNav.bind(this, { button })
    );
  }

  toggleMobileNav({ button }) {
    const header = button.closest(`.${this.classNames.header}`);

    this.toggleHeader({ header });
    this.toggleBodyOverflowHidden();
  }

  toggleHeader({ header }) {
    if (!header) {
      return;
    }

    header.classList.toggle(this.classNames.headerOpen);
  }

  handleStickyHeader({ header }) {
    if (!header) {
      return;
    }

    window.addEventListener(
      'scroll',
      this.toggleHeaderSticky.bind(this, { header })
    );
  }

  toggleHeaderSticky({ header }) {
    if (!header) {
      return;
    }

    header.classList.toggle(this.classNames.headerSticky, window.scrollY > 10);
    header.classList.toggle(
      this.classNames.headerStickyVisible,
      this.pageScrollTop > window.scrollY
    );

    this.pageScrollTop = window.scrollY;
  }

  toggleBodyOverflowHidden() {
    document.body.classList.toggle(this.classNames.bodyOverflowHidden);
  }

  onHistoryChange() {
    window.addEventListener('popstate', () => {
      const header = document.querySelector(`.${this.classNames.header}`);
      const { hash } = window.location;

      if (!hash) {
        return;
      }

      if (header) {
        const hashElement = document.querySelector(hash);

        if (!hashElement) {
          return;
        }

        document.body.classList.remove(this.classNames.bodyOverflowHidden);
        header.classList.remove(this.classNames.headerOpen);
      }
    });
  }

  onClickOutside({ element, callBack }) {
    document.addEventListener('click', (event) => {
      if (
        !element.contains(event.target) ||
        this.isMegaMenu({ element: event.target })
      ) {
        callBack();
      }
    });
  }

  isMegaMenu({ element }) {
    return (
      element.parentNode.classList.contains(this.classNames.megaMenuBlock) ||
      element.classList.contains(this.classNames.megaMenuBlock)
    );
  }

  handleHeaderHovered({ header }) {
    header.addEventListener('mouseenter', () => {
      this.headerHovered({ flag: true, header });
    });

    header.addEventListener('mouseleave', () => {
      this.headerHovered({ flag: false, header });
    });
  }

  headerHovered({ header, flag }) {
    header.classList.toggle(this.classNames.headerHovered, flag);
  }
}

new Header().initialize();



// WEBPACK FOOTER //
// ./scripts/blocks/header.js